export default "__VITE_ASSET__DkVIeq2l__"